import { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { BaseMUIComponentProps } from '../types/Types';

export type SelectItem = {
    id: string;
    name: string;
};

/**
 * Props for the SelectComponent
 */
interface SelectComponentProps extends BaseMUIComponentProps {
    items: SelectItem[];
    initialSelection?: SelectItem;
    handleSelectedValues: (value: SelectItem | null) => void;
    required?: boolean;
};

/**
 * MUI Select Component
 * @param items The items to select from
 * @param initialSelection Optional initial selection of items
 * @param handleSelectedValues Callback function to handle selected values
 * @param required Whether the select field is required
 * @returns 
 */
export function SelectComponent({
    className = '',
    label = 'Sélectionner des éléments',
    items,
    initialSelection = undefined,
    handleSelectedValues,
    required = true,
    ...props
}: SelectComponentProps) {
    const [value, setValue] = useState<SelectItem | null>(initialSelection ?? null);

    const handleChange = (event: SelectChangeEvent<string>) => {
        const selectedId = event.target.value;
        const selectedItem = items.find((item) => item.id === selectedId) || null;
        setValue(selectedItem);
        handleSelectedValues(selectedItem);
    };

    return (
        <FormControl fullWidth margin="normal" className={className} required={required}>
            <InputLabel id={`select-label-${label.replace(/\s+/g, '-').toLowerCase()}`}
            >{label}</InputLabel>
            <Select
                className={className}
                labelId={`select-label-${label.replace(/\s+/g, '-').toLowerCase()}`}
                label={label}
                value={value ? value.id : ''}
                variant="outlined"
                onChange={handleChange}
            >
                {items.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}